import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl;
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class ProcessServe {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 新增数据
  public addProcessData(opts: object) {
    const url = serverUrl + '/api/flowManage/flowFormGroup';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 查询单条数据
  public getProcessDataById(id: any) {
    const url = serverUrl + '/api/flowManage/flowForm/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 查询单条流程设计数据
  public getFlowProcessDataById(id: any) {
    const url = serverUrl + '/api/flowManage/flowDesign/flowNode/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 查询单条表单设计数据
  public getFromProcessDataById(id: any) {
    const url = serverUrl + '/api/flowManage/flowDesign/formControl/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 修改数据
  public updateProcessData(opts: object) {
    const url = serverUrl + '/api/flowManage/flowFormGroup';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 查询数据 分组
  public getProcessData(opts: object) {
    const url = serverUrl + '/api/flowManage/flowFormGroup/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询数据 流程控件
  public getFlowFormData(opts: object) {
    const url = serverUrl + '/api/flowManage/flowForm/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 删除数据
  public deleteProcessData(opts: object) {
    const url = serverUrl + '/api/flowManage/flowFormGroup?idList=' + opts;
    return this.rSerivce.serverObj.delete(url);
  }

  // 新增工作流
  public addFlowForm(opts: object) {
    const url = serverUrl + '/api/flowManage/flowForm';
    return this.rSerivce.serverObj.post(url, opts);
  }

  //获取高级配置
  public getOneFlowConfig(flowFormId: string) {
    const url = serverUrl + '/api/flowManage/flowConfig/' + flowFormId;
    return this.rSerivce.serverObj.get(url);
  }
  //编辑高级配置信息
  public getFlowConfig(flowFormId: string, opts: any) {
    const url = serverUrl + '/api/flowManage/flowConfig/' + flowFormId;
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 修改工作流
  public editFlowForm(opts: object, id: any) {
    const url = serverUrl + '/api/flowManage/flowForm/' + id;
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 启用/停用
  public enableFlowForm(opts: object) {
    const url = serverUrl + '/api/flowManage/flowForm/enable' + changePostParam(opts);
    return this.rSerivce.serverObj.post(url);
  }

  // 根据code 分页查询流程实例列表
  public getFlowExample(opts: object) {
    const url = serverUrl + '/api/flowManage/flowExample';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 根据code 分页查询流程实例节点、表单信息
  public getFlowExampleInfo(code: string) {
    const url = serverUrl + '/api/flowManage/flowExample/getStartExampleNeedInfoByCode/' + code;
    return this.rSerivce.serverObj.get(url);
  }

  // 根据code 获取id
  public getIdByCode(code: string) {
    const url = serverUrl + '/api/flowManage/flowForm/getFlowFormIdByCode/' + code;
    return this.rSerivce.serverObj.get(url);
  }

  // 发起流程
  public startFlowExample(opts: any, id: string) {
    const url = serverUrl + '/api/flowManage/flowExample/create/' + id;
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 获取可操作内容
  public getOperateContent(id: string) {
    const url = serverUrl + '/api/flowManage/flowExample/getOperateContent/' + id;
    return this.rSerivce.serverObj.get(url);
  }

  // 处理节点
  public handleFlowExample(opts: any, id: string) {
    const url = serverUrl + '/api/flowManage/flowExample/handle/' + id;
    return this.rSerivce.serverObj.post(url, opts);
  }

  public getFlowExampleLog(id: string) {
    const url = serverUrl + '/api/flowManage/flowExample/log/' + id;
    return this.rSerivce.serverObj.get(url);
  }
}
